import router from "./router/router"; 
import { navigateTo } from "./router/navigation";

// utils to delay promise
function wait (ms: any) {
  return (x:any) => {
    return new Promise(resolve => setTimeout(() => resolve(x), ms))
  }
}

const sortProperties = (properties: any[]) => properties.sort((a, b) => a.name === b.name ? 0 : a.name < b.name ? -1 : 1);


const sortByName = sortProperties


/**
 * Navigates to a specified route. If the current domain is different from the target domain,
 * it redirects the browser to the target domain with the specified route path. Otherwise,
 * it uses the `navigateTo` function to navigate within the same domain.
 *
 * @param {string} routeName - The name of the route to navigate to.
 */
function navigateToRoute(routeName: string, params?: any): void {
  const currentDomain = window.location.origin;
  const targetDomain = process.env.VUE_APP_ROOMCHOICE_APP_URL;

  if (currentDomain !== targetDomain) {
    const route = router.resolve({ name: routeName, params });
    const routePath = route.href;
    var queryParams = ""
    if (localStorage.token && localStorage.user && localStorage.organizationID) {
      queryParams = `?user=${localStorage.user}&token=${localStorage.token}&organizationID=${localStorage.organizationID}`
    }
    const targetUrl = `${targetDomain}${routePath}${queryParams}`;
    window.location.href = targetUrl;
  } else {
    navigateTo(routeName, params);
  }
}

export { wait, sortProperties, sortByName, navigateToRoute }
